(function () {
  'use strict';

  if (!window.__excludePublishers) return;

  var vendorSet = null;
  var handleSet = null;
  var isBootstrapping = false;
  var indexBuildToken = 0;

  var INDEX_CACHE_TTL = 10 * 60 * 1000;
  var INDEX_CACHE_VERSION = 'v6';
  var PARALLEL_BATCH = 8;
  var META_CACHE_PREFIX = 'kitaboo-product-meta:v1:';
  var META_CACHE_TTL = 30 * 60 * 1000;
  var META_FETCH_BATCH = 24;
  var metaCacheMemory = new Map();

  var activeIndex = null;
  var baseVisibleIndex = null;
  var currentVisiblePage = 1;
  var savedCardTemplate = null;
  var renderVisiblePageToken = 0;

  function isValidCardTemplate(node) {
    if (!node || !node.classList || !node.classList.contains('grid__item')) return false;
    if (node.classList.contains('grid__item--full-width')) return false;
    return !!(
      node.querySelector('.card-wrapper, .product-card-wrapper, .card__heading, a[href*="/products/"]')
    );
  }

  function resetCardTemplate() {
    savedCardTemplate = null;
  }

  function normalizeProductImageUrl(url) {
    if (!url) return '';
    var value = String(url).trim();
    if (!value) return '';
    if (value.indexOf('//') === 0) return 'https:' + value;
    return value;
  }

  function rememberCardTemplate(ctx) {
    if (!ctx || !ctx.grid || savedCardTemplate) return;
    var candidate = ctx.grid.querySelector('.grid__item[data-vendor], .grid__item[data-product-handle]');
    if (!isValidCardTemplate(candidate)) {
      candidate = ctx.grid.querySelector('.grid__item');
    }
    if (!isValidCardTemplate(candidate)) return;
    savedCardTemplate = candidate.cloneNode(true);
  }

  function getCardTemplate(ctx) {
    if (savedCardTemplate) return savedCardTemplate;
    if (!ctx || !ctx.grid) return null;
    var live = ctx.grid.querySelector('.grid__item[data-vendor], .grid__item[data-product-handle]');
    if (!isValidCardTemplate(live)) {
      live = ctx.grid.querySelector('.grid__item');
    }
    if (!isValidCardTemplate(live)) return null;
    savedCardTemplate = live.cloneNode(true);
    return savedCardTemplate;
  }

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function initSets() {
    if (vendorSet) return;
    vendorSet = new Set((window.__excludedPublisherVendors || []).map(normalize));
    handleSet = new Set((window.__excludedPublisherHandles || []).map(normalize));
  }

  function isExcludedVendor(vendor) {
    initSets();
    var normalized = normalize(vendor);
    if (!normalized) return false;
    return vendorSet.has(normalized) || handleSet.has(normalized);
  }

  function hasActiveFacetFilters() {
    var params = new URLSearchParams(window.location.search);
    var entries = params.entries();
    var entry = entries.next();
    while (!entry.done) {
      var key = entry.value[0];
      var value = entry.value[1];
      if (key === 'q' && value) return true;
      if (key.indexOf('filter.') === 0 && value) return true;
      entry = entries.next();
    }
    return false;
  }

  function getSortKey() {
    var params = new URLSearchParams(window.location.search);
    return params.get('sort_by') || 'default';
  }

  function sortVisibleProducts(products) {
    var sortBy = getSortKey();
    if (!sortBy || sortBy === 'default' || sortBy === 'manual' || sortBy === 'best-selling') {
      return products;
    }

    var sorted = products.slice();
    sorted.sort(function (a, b) {
      if (sortBy === 'title-ascending') return String(a.title).localeCompare(String(b.title));
      if (sortBy === 'title-descending') return String(b.title).localeCompare(String(a.title));
      if (sortBy === 'price-ascending') return (parseFloat(a.price, 10) || 0) - (parseFloat(b.price, 10) || 0);
      if (sortBy === 'price-descending') return (parseFloat(b.price, 10) || 0) - (parseFloat(a.price, 10) || 0);
      if (sortBy === 'created-ascending' || sortBy === 'published-ascending') {
        return (parseInt(a.id, 10) || 0) - (parseInt(b.id, 10) || 0);
      }
      if (sortBy === 'created-descending' || sortBy === 'published-descending') {
        return (parseInt(b.id, 10) || 0) - (parseInt(a.id, 10) || 0);
      }
      return 0;
    });
    return sorted;
  }

  function getSortedIndex(index) {
    if (!index || !Array.isArray(index.products)) return index;
    return {
      products: sortVisibleProducts(index.products),
      complete: index.complete,
      nextRawPage: index.nextRawPage,
      ts: index.ts
    };
  }

  function getCurrentPage() {
    var params = new URLSearchParams(window.location.search);
    var page = parseInt(params.get('page'), 10);
    return Number.isFinite(page) && page > 0 ? page : 1;
  }

  function getGridContext() {
    var grid = document.getElementById('product-grid');
    if (!grid || grid.dataset.exclusionPagination !== 'true') return null;
    return {
      grid: grid,
      handle: grid.dataset.collectionHandle,
      perPage: parseInt(grid.dataset.productsPerPage, 10) || 16,
      sectionId: grid.dataset.sectionId || '',
      showVendor: grid.dataset.showVendor === 'true',
      showQuickAdd: grid.dataset.showQuickAdd === 'true',
      addToCartLabel: grid.dataset.addToCartLabel || 'Add to cart',
      soldOutLabel: grid.dataset.soldOutLabel || 'Sold out',
      chooseOptionsLabel: grid.dataset.chooseOptionsLabel || 'Choose options',
      allProductsCount: parseInt(grid.dataset.allProductsCount, 10) || 0,
      container: document.getElementById('ProductGridContainer')
    };
  }

  function getInitialJsonPages(ctx) {
    var total = ctx && ctx.allProductsCount ? ctx.allProductsCount : 0;
    if (total > 8000) return 12;
    if (total > 3000) return 8;
    if (total > 1000) return 6;
    return 4;
  }

  function getIndexCacheKey(handle) {
    return 'kitaboo-visible-index:' + INDEX_CACHE_VERSION + ':' + handle;
  }

  function mergeProductRecord(existing, incoming) {
    if (!existing) return incoming;
    if (!incoming) return existing;

    var merged = {
      id: incoming.id || existing.id,
      handle: incoming.handle || existing.handle,
      title: incoming.title || existing.title,
      vendor: incoming.vendor || existing.vendor,
      image: incoming.image || existing.image,
      price: incoming.price || existing.price,
      compareAtPrice: incoming.compareAtPrice != null ? incoming.compareAtPrice : existing.compareAtPrice,
      available: incoming.available !== false ? incoming.available : existing.available,
      variantId: incoming.variantId || existing.variantId,
      variantCount: incoming.variantCount || existing.variantCount,
      fromServer: !!(existing.fromServer && incoming.fromServer),
      l1: incoming.l1 || existing.l1,
      l2: incoming.l2 || existing.l2,
      l3: incoming.l3 || existing.l3,
      l4: incoming.l4 || existing.l4
    };

    if (!incoming.fromServer && existing.fromServer) {
      merged.fromServer = false;
    }

    return merged;
  }

  function mergeProductLists(existing, incoming) {
    var map = new Map();
    (existing || []).concat(incoming || []).forEach(function (product) {
      var key = product.handle || String(product.id || '');
      if (!key) return;
      if (!map.has(key)) {
        map.set(key, product);
        return;
      }
      map.set(key, mergeProductRecord(map.get(key), product));
    });
    return Array.from(map.values());
  }

  function parsePriceFromDom(li) {
    var priceEl = li.querySelector('.price-item--sale, .price-item--last, .price-item--regular, .price .price-item');
    if (!priceEl) return '';
    var raw = (priceEl.textContent || '').replace(/[^\d.,]/g, '').replace(/,/g, '');
    var parsed = parseFloat(raw, 10);
    return Number.isFinite(parsed) ? String(parsed) : '';
  }

  function readIndexCache(handle) {
    try {
      var raw = sessionStorage.getItem(getIndexCacheKey(handle));
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.products)) return null;
      if (Date.now() - data.ts > INDEX_CACHE_TTL) return null;
      return data;
    } catch (error) {
      return null;
    }
  }

  function writeIndexCache(handle, index) {
    try {
      sessionStorage.setItem(
        getIndexCacheKey(handle),
        JSON.stringify({
          products: index.products,
          complete: !!index.complete,
          nextRawPage: index.nextRawPage || 1,
          ts: Date.now()
        })
      );
    } catch (error) {
      /* ignore quota errors */
    }
  }

  function extractServerRenderedProducts(ctx) {
    if (!ctx || !ctx.grid) return [];
    var products = [];
    var seen = new Set();

    ctx.grid.querySelectorAll('.grid__item[data-vendor]').forEach(function (li) {
      var handle = li.getAttribute('data-product-handle') || '';
      if (!handle) {
        var link = li.querySelector('a[href*="/products/"]');
        if (!link) return;
        var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/i);
        if (!match) return;
        handle = decodeURIComponent(match[1]);
      }
      if (!handle || seen.has(handle)) return;
      seen.add(handle);

      var productId = li.getAttribute('data-product-id') || handle;
      var titleEl = li.querySelector('.card__heading');
      var img = li.querySelector('.card__media img, img');
      var variantBtn = li.querySelector('.quick-add__submit[data-variant-id]');
      var variantId = variantBtn ? variantBtn.getAttribute('data-variant-id') : '';
      var price = parsePriceFromDom(li);
      products.push({
        id: productId,
        handle: handle,
        title: titleEl ? titleEl.textContent.trim() : '',
        vendor: li.getAttribute('data-vendor') || '',
        image: img ? normalizeProductImageUrl(img.currentSrc || img.getAttribute('src') || '') : '',
        price: price,
        compareAtPrice: null,
        available: true,
        variantId: variantId,
        variantCount: variantId ? 1 : 0,
        fromServer: true,
        l1: li.getAttribute('data-l1') || '',
        l2: li.getAttribute('data-l2') || '',
        l3: li.getAttribute('data-l3') || '',
        l4: li.getAttribute('data-l4') || ''
      });
    });

    return products;
  }

  function hasServerRenderedPage(ctx, page) {
    if (!ctx || !ctx.grid || page !== 1) return false;
    return ctx.grid.querySelectorAll('.grid__item[data-vendor]').length > 0;
  }

  function refreshVisibleView() {
    var ctx = getGridContext();
    if (!ctx || !activeIndex || hasActiveFacetFilters()) return;
    var page = getCurrentPage();
    currentVisiblePage = page;
    renderVisiblePage(ctx, activeIndex, page);
    renderPagination(ctx, page);
  }

  function setProductCount(total, options) {
    var opts = options || {};
    if (hasActiveFacetFilters() && !opts.filtered) {
      return;
    }

    var ctx = getGridContext();
    var perPage = ctx && ctx.perPage ? ctx.perPage : 16;
    var safeTotal = Number.isFinite(total) ? total : 0;
    var text;

    if (safeTotal === 0) {
      text = '0 products';
    } else if (safeTotal === 1) {
      text = '1 product';
    } else if (opts.approximate) {
      text = safeTotal + '+ products';
    } else {
      text = safeTotal + ' products';
    }

    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(function (el) {
      if (!el) return;
      el.textContent = text;
      el.dataset.countReady = 'true';
      if (opts.approximate) {
        el.dataset.countApproximate = 'true';
      } else {
        delete el.dataset.countApproximate;
      }
    });
  }

  function notifyVisibleIndexUpdated() {
    if (!activeIndex || !Array.isArray(activeIndex.products)) return;
    document.dispatchEvent(
      new CustomEvent('kitaboo:visible-index-updated', {
        detail: {
          products: activeIndex.products.slice(),
          complete: !!activeIndex.complete
        }
      })
    );
  }

  function hidePendingCounts() {
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(function (el) {
      if (!el || el.dataset.countReady === 'true') return;
      var text = String(el.textContent || '').trim();
      if (text && /\d/.test(text)) return;
      el.textContent = '…';
    });
  }

  function fetchProductsJsonPage(collectionHandle, page) {
    return fetch(
      '/collections/' + encodeURIComponent(collectionHandle) + '/products.json?limit=250&page=' + page,
      { credentials: 'same-origin' }
    )
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function mapVisibleProducts(data) {
    if (!data || !Array.isArray(data.products)) return { products: [], hasMore: false };
    var products = [];
    data.products.forEach(function (product) {
      if (isExcludedVendor(product.vendor)) return;
      var variant = (product.variants && product.variants[0]) || {};
      var image = (product.images && product.images[0]) || product.image || {};
      products.push({
        id: product.id,
        title: product.title,
        handle: product.handle,
        vendor: product.vendor,
        image: normalizeProductImageUrl(image.src || ''),
        price: variant.price,
        compareAtPrice: variant.compare_at_price,
        available: variant.available !== false,
        variantId: variant.id || '',
        productType: product.product_type || '',
        variantCount: Array.isArray(product.variants) ? product.variants.length : 0
      });
    });
    return {
      products: products,
      hasMore: data.products.length >= 250
    };
  }

  function fetchJsonPageBatch(collectionHandle, startPage, count) {
    var requests = [];
    for (var i = 0; i < count; i += 1) {
      requests.push(fetchProductsJsonPage(collectionHandle, startPage + i));
    }
    return Promise.all(requests).then(function (results) {
      var products = [];
      var hasMore = false;
      results.forEach(function (data) {
        var mapped = mapVisibleProducts(data);
        products = products.concat(mapped.products);
        if (mapped.hasMore) hasMore = true;
      });
      return { products: products, hasMore: hasMore };
    });
  }

  function buildVisibleIndex(ctx, maxInitialPages, seedProducts) {
    var token = ++indexBuildToken;
    var cached = readIndexCache(ctx.handle);

    if (cached && cached.complete) {
      activeIndex = {
        products: mergeProductLists(seedProducts, cached.products),
        complete: true,
        nextRawPage: cached.nextRawPage || 1,
        ts: Date.now()
      };
      syncBaseVisibleIndex(activeIndex);
      return Promise.resolve(activeIndex);
    }

    if (cached && !cached.complete) {
      activeIndex = {
        products: mergeProductLists(seedProducts, cached.products),
        complete: false,
        nextRawPage: cached.nextRawPage || maxInitialPages + 1,
        ts: Date.now()
      };
      syncBaseVisibleIndex(activeIndex);
      continueIndexBuild(ctx, activeIndex, token, activeIndex.nextRawPage);
      return Promise.resolve(activeIndex);
    }

    return fetchJsonPageBatch(ctx.handle, 1, maxInitialPages).then(function (batch) {
      if (token !== indexBuildToken) return activeIndex;

      var index = {
        products: mergeProductLists(seedProducts, batch.products),
        complete: !batch.hasMore,
        nextRawPage: maxInitialPages + 1,
        ts: Date.now()
      };
      activeIndex = index;
      syncBaseVisibleIndex(index);
      writeIndexCache(ctx.handle, index);
      setProductCount(index.products.length, { approximate: !index.complete });
      notifyVisibleIndexUpdated();
      if (hasActiveFacetFilters() && document.querySelector('[data-large-collection="true"]')) {
        renderFilteredFromBase(ctx);
      } else {
        refreshVisibleView();
      }

      if (!index.complete) {
        continueIndexBuild(ctx, index, token, maxInitialPages + 1);
      }

      return index;
    });
  }

  function continueIndexBuild(ctx, index, token, startPage) {
    function fetchNext(start) {
      if (token !== indexBuildToken) return Promise.resolve();

      return fetchJsonPageBatch(ctx.handle, start, PARALLEL_BATCH).then(function (batch) {
        if (token !== indexBuildToken) return;

        index.products = mergeProductLists(index.products, batch.products);
        index.ts = Date.now();
        syncBaseVisibleIndex(index);
        writeIndexCache(ctx.handle, index);
        setProductCount(index.products.length, { approximate: !index.complete });
        notifyVisibleIndexUpdated();
        if (hasActiveFacetFilters()) {
          renderFilteredFromBase(ctx);
        } else {
          refreshVisibleView();
        }

        if (!batch.hasMore) {
          index.complete = true;
          syncBaseVisibleIndex(index);
          writeIndexCache(ctx.handle, index);
          setProductCount(index.products.length);
          notifyVisibleIndexUpdated();
          if (hasActiveFacetFilters()) {
            renderFilteredFromBase(ctx);
          } else {
            refreshVisibleView();
          }
          return;
        }

        index.nextRawPage = start + PARALLEL_BATCH;
        writeIndexCache(ctx.handle, index);
        return fetchNext(start + PARALLEL_BATCH);
      });
    }

    window.setTimeout(function () {
      fetchNext(startPage);
    }, 0);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatPrice(amount) {
    var num = parseFloat(amount, 10);
    if (!Number.isFinite(num)) return '';
    return 'Rs. ' + num.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function buildPriceHtml(product) {
    var price = formatPrice(product.price);
    var compareAt = product.compareAtPrice ? parseFloat(product.compareAtPrice, 10) : 0;
    var current = parseFloat(product.price, 10);
    if (compareAt > current) {
      return (
        '<div class="price price--on-sale">' +
        '<span class="price-item price-item--sale">' + escapeHtml(price) + '</span>' +
        '<span class="price-item price-item--regular"><s>' + escapeHtml(formatPrice(product.compareAtPrice)) + '</s></span>' +
        '</div>'
      );
    }
    return '<div class="price"><span class="price-item price-item--regular">' + escapeHtml(price) + '</span></div>';
  }

  function buildQuickAddHtml(product, ctx) {
    if (!ctx.showQuickAdd) return '';

    var href = '/products/' + encodeURIComponent(product.handle);
    var chooseLabel = escapeHtml(ctx.chooseOptionsLabel || 'Choose options');
    var addLabel = escapeHtml(ctx.addToCartLabel || 'Add to cart');
    var soldOutLabel = escapeHtml(ctx.soldOutLabel || 'Sold out');

    if ((product.variantCount && product.variantCount > 1) || !product.variantId) {
      return (
        '<div class="quick-add no-js-hidden">' +
          '<a href="' + href + '" class="quick-add__submit button button--full-width button--secondary">' +
            chooseLabel +
          '</a>' +
        '</div>'
      );
    }

    var formId = 'quick-add-' + escapeHtml(ctx.sectionId) + '-' + escapeHtml(String(product.id));
    var variantId = escapeHtml(String(product.variantId));
    var disabledAttr = product.available === false ? ' disabled' : '';

    return (
      '<div class="quick-add no-js-hidden">' +
        '<product-form>' +
          '<form id="' + formId + '" class="form" novalidate="novalidate" data-type="add-to-cart-form">' +
            '<input type="hidden" name="id" value="' + variantId + '">' +
            '<button type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" data-variant-id="' + variantId + '"' + disabledAttr + '>' +
              '<span>' + (product.available === false ? soldOutLabel : addLabel) + '</span>' +
              '<div class="loading-overlay__spinner hidden">' +
                '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
                  '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
                '</svg>' +
              '</div>' +
            '</button>' +
          '</form>' +
        '</product-form>' +
      '</div>'
    );
  }

  function getCardContentRoot(card) {
    if (!card) return null;
    var outer = card.querySelector(':scope > .card__content');
    if (outer) return outer;
    var contents = card.querySelectorAll('.card__content');
    return contents.length ? contents[contents.length - 1] : null;
  }

  function syncQuickAdd(clone, product, ctx) {
    clone.querySelectorAll('.quick-add').forEach(function (node) {
      node.remove();
    });

    if (!ctx.showQuickAdd) return;

    var card = clone.querySelector('.card');
    if (!card) return;

    var content = getCardContentRoot(card);
    if (!content) return;

    content.insertAdjacentHTML('beforeend', buildQuickAddHtml(product, ctx));
  }

  function buildProductCardHtml(product, ctx) {
    var href = '/products/' + encodeURIComponent(product.handle);
    var title = escapeHtml(product.title);
    var vendorHtml = ctx.showVendor
      ? '<div class="caption-with-letter-spacing light">' + escapeHtml(product.vendor) + '</div>'
      : '';
    var imageHtml = product.image
      ? (function () {
          var base = String(product.image).split('?')[0];
          return (
            '<img src="' + escapeHtml(base + '?width=533') + '" srcset="' + escapeHtml(buildShopifyImageSrcset(base)) + '" alt="' + title + '" loading="lazy" class="motion-reduce" width="533" height="533">'
          );
        })()
      : '';

    var quickAddHtml = buildQuickAddHtml(product, ctx);

    return (
      '<li class="grid__item" data-product-handle="' + escapeHtml(product.handle) + '" data-vendor="' + escapeHtml(product.vendor) + '">' +
        '<div class="card-wrapper product-card-wrapper kitaboo-product-card underline-links-hover">' +
          '<div class="card card--standard card--media">' +
            '<div class="card__inner ratio" style="--ratio-percent: 125%;">' +
              '<div class="card__media">' +
                '<div class="media media--transparent media--hover-effect">' +
                  '<a href="' + href + '" class="full-unstyled-link">' + imageHtml + '</a>' +
                '</div>' +
              '</div>' +
            '</div>' +
            '<div class="card__content">' +
              '<div class="card__information">' +
                '<h3 class="card__heading h5">' +
                  '<a href="' + href + '" class="full-unstyled-link">' + title + '</a>' +
                '</h3>' +
                '<div class="card-information">' + vendorHtml + buildPriceHtml(product) + '</div>' +
              '</div>' +
              quickAddHtml +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>'
    );
  }

  function buildShopifyImageSrcset(imageUrl) {
    if (!imageUrl) return '';
    var base = String(imageUrl).split('?')[0];
    return [165, 360, 533, 720, 940, 1066]
      .map(function (width) {
        return base + '?width=' + width + ' ' + width + 'w';
      })
      .join(', ');
  }

  function syncProductCardImage(clone, product) {
    var mediaWrapper = clone.querySelector('.card__media');
    if (!mediaWrapper) return;

    var mediaInner = mediaWrapper.querySelector('.media') || mediaWrapper;
    var imageUrl = normalizeProductImageUrl(product.image);

    if (!imageUrl) {
      mediaInner.innerHTML = '';
      return;
    }

    var baseUrl = imageUrl.split('?')[0];
    var alt = escapeHtml(product.title || '');
    mediaInner.innerHTML =
      '<img src="' +
      escapeHtml(baseUrl + '?width=533') +
      '" srcset="' +
      escapeHtml(buildShopifyImageSrcset(baseUrl)) +
      '" sizes="(min-width: 1200px) 270px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="' +
      alt +
      '" loading="lazy" class="motion-reduce" width="533" height="533">';
  }

  function enrichSliceImages(slice) {
    var pending = (slice || []).filter(function (product) {
      return product && product.handle && !product.image;
    });
    if (!pending.length) return Promise.resolve(slice);

    return Promise.all(
      pending.map(function (product) {
        return fetch('/products/' + encodeURIComponent(product.handle) + '.json', {
          credentials: 'same-origin'
        })
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (data) {
            if (!data || !data.product) return;
            var image = (data.product.images && data.product.images[0]) || data.product.image || {};
            product.image = normalizeProductImageUrl(image.src || '');
          })
          .catch(function () {});
      })
    ).then(function () {
      return slice;
    });
  }

  function cloneProductCard(product, template, ctx) {
    if (!template || !isValidCardTemplate(template)) return null;
    var clone = template.cloneNode(true);
    clone.classList.remove('deferred-card');
    clone.removeAttribute('hidden');
    clone.setAttribute('data-vendor', product.vendor || '');
    clone.setAttribute('data-product-handle', product.handle || '');

    var links = clone.querySelectorAll('a[href*="/products/"]');
    var href = '/products/' + encodeURIComponent(product.handle);
    links.forEach(function (link) {
      link.setAttribute('href', href);
    });

    var headings = clone.querySelectorAll('.card__heading, .card__heading a');
    headings.forEach(function (node) {
      if (node.tagName === 'A' || node.classList.contains('card__heading')) {
        if (node.children.length === 0 || node.tagName === 'A') {
          node.textContent = product.title;
        }
      }
    });

    syncProductCardImage(clone, product);

    if (product.price && !product.fromServer) {
      var priceRoot = clone.querySelector('.price');
      if (priceRoot) {
        priceRoot.outerHTML = buildPriceHtml(product);
      }
    }

    if (ctx.showVendor) {
      var vendorEl = clone.querySelector('.caption-with-letter-spacing');
      if (vendorEl) vendorEl.textContent = product.vendor || '';
    }

    syncQuickAdd(clone, product, ctx);

    return clone;
  }

  function setGridLoading(ctx, loading) {
    if (!ctx || !ctx.grid) return;
    ctx.grid.classList.toggle('kitaboo-plp-grid--loading', !!loading);
    var overlay = ctx.container ? ctx.container.querySelector('.loading-overlay') : null;
    if (overlay) overlay.classList.toggle('hidden', !loading);
  }

  function renderVisiblePage(ctx, index, page) {
    if (!ctx || !index) return;

    currentVisiblePage = page;
    var sortedIndex = getSortedIndex(index);

    var perPage = ctx.perPage;
    var totalPages = Math.max(1, Math.ceil(sortedIndex.products.length / perPage) || 1);
    var safePage = Math.min(Math.max(page, 1), totalPages);
    var start = (safePage - 1) * perPage;
    var slice = sortedIndex.products.slice(start, start + perPage);
    var renderToken = ++renderVisiblePageToken;

    if (slice.length === 0 && !index.complete && hasServerRenderedPage(ctx, safePage)) {
      ctx.grid.dataset.kitabooHydrated = 'partial';
      return;
    }

    var template = getCardTemplate(ctx);
    ctx.grid.innerHTML = '';

    if (slice.length === 0 && !index.complete) {
      ctx.grid.dataset.kitabooHydrated = 'pending';
      var loading = document.createElement('li');
      loading.className = 'grid__item grid__item--full-width';
      loading.innerHTML = '<p class="kitaboo-plp-empty">Loading products…</p>';
      ctx.grid.appendChild(loading);
      return;
    }

    ctx.grid.dataset.kitabooHydrated = 'true';

    if (slice.length === 0) {
      var empty = document.createElement('li');
      empty.className = 'grid__item grid__item--full-width';
      empty.innerHTML = '<p class="kitaboo-plp-empty">No products found in this collection.</p>';
      ctx.grid.appendChild(empty);
      return;
    }

    enrichSliceImages(slice).then(function (enrichedSlice) {
      if (renderToken !== renderVisiblePageToken) return;

      enrichedSlice.forEach(function (product) {
        var card = cloneProductCard(product, template, ctx);
        if (!card) {
          ctx.grid.insertAdjacentHTML('beforeend', buildProductCardHtml(product, ctx));
        } else {
          ctx.grid.appendChild(card);
        }
      });

      document.dispatchEvent(new CustomEvent('product-grid:updated'));

      if (typeof window.markCartQuickAddState === 'function') {
        window.markCartQuickAddState();
      }
    });
  }

  function getPaginationMount() {
    return document.querySelector('[data-kitaboo-pagination-mount]');
  }

  function buildPageList(current, total) {
    var pages = [];
    if (total <= 7) {
      for (var i = 1; i <= total; i += 1) pages.push(i);
      return pages;
    }

    pages.push(1);
    if (current > 3) pages.push('…');
    for (var j = Math.max(2, current - 1); j <= Math.min(total - 1, current + 1); j += 1) {
      pages.push(j);
    }
    if (current < total - 2) pages.push('…');
    pages.push(total);
    return pages;
  }

  function pageUrl(page) {
    var url = new URL(window.location.href);
    if (page <= 1) url.searchParams.delete('page');
    else url.searchParams.set('page', String(page));
    return url.pathname + url.search;
  }

  function renderPagination(ctx, currentPage) {
    var mount = getPaginationMount();
    if (!mount || !activeIndex) return;

    var sortedIndex = getSortedIndex(activeIndex);
    if (!activeIndex.complete && sortedIndex.products.length === 0) {
      mount.innerHTML = '';
      mount.hidden = true;
      return;
    }

    var total = Math.max(1, Math.ceil(sortedIndex.products.length / ctx.perPage) || 1);
    var current = Math.min(Math.max(currentPage || 1, 1), total);

    if (total <= 1) {
      mount.innerHTML = '';
      mount.hidden = true;
      return;
    }

    mount.hidden = false;
    var parts = buildPageList(current, total);
    var html = '<nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled" role="list">';

    if (current > 1) {
      html += '<li><a href="' + pageUrl(current - 1) + '" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" data-kitaboo-page="' + (current - 1) + '" aria-label="Previous page">‹</a></li>';
    }

    parts.forEach(function (part) {
      if (part === '…') {
        html += '<li><span class="pagination__item">…</span></li>';
        return;
      }
      if (part === current) {
        html += '<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page">' + part + '</a></li>';
      } else {
        html += '<li><a href="' + pageUrl(part) + '" class="pagination__item link" data-kitaboo-page="' + part + '">' + part + '</a></li>';
      }
    });

    if (current < total) {
      html += '<li><a href="' + pageUrl(current + 1) + '" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" data-kitaboo-page="' + (current + 1) + '" aria-label="Next page">›</a></li>';
    }

    html += '</ul></nav>';
    mount.innerHTML = html;

    mount.querySelectorAll('[data-kitaboo-page]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var nextPage = parseInt(link.getAttribute('data-kitaboo-page'), 10);
        if (!Number.isFinite(nextPage)) return;
        var url = pageUrl(nextPage);
        window.history.pushState({ kitabooVisiblePage: nextPage }, '', url);
        renderVisiblePage(ctx, activeIndex, nextPage);
        renderPagination(ctx, nextPage);
        if (ctx.container) {
          ctx.container.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function syncBaseVisibleIndex(index) {
    if (!index || !Array.isArray(index.products)) return;
    baseVisibleIndex = {
      products: index.products.slice(),
      complete: !!index.complete,
      nextRawPage: index.nextRawPage || 1,
      ts: index.ts || Date.now()
    };
  }

  function shouldExcludeFilterParamForDimension(paramKey, dimension) {
    if (dimension === 'publisher') return paramKey === 'filter.p.vendor';
    if (dimension === 'category') return paramKey === 'filter.p.product_type';
    if (dimension === 'subCategory') return paramKey.indexOf('combined_product_tags') !== -1;
    if (dimension === 'author') return paramKey.indexOf('author') !== -1;
    if (dimension === 'bookType') return paramKey.indexOf('book_type') !== -1;
    return false;
  }

  function excludeFilterParamForDimension(filters, dimension) {
    var next = {
      byParam: {},
      priceMin: filters.priceMin,
      priceMax: filters.priceMax
    };
    Object.keys(filters.byParam).forEach(function (key) {
      if (!shouldExcludeFilterParamForDimension(key, dimension)) {
        next.byParam[key] = filters.byParam[key].slice();
      }
    });
    return next;
  }

  var FACET_DIMENSION_PARAMS = {
    publisher: 'filter.p.vendor',
    category: 'filter.p.product_type',
    subCategory: 'filter.p.m.custom.combined_product_tags',
    author: 'filter.p.m.custom.author',
    bookType: 'filter.p.m.custom.book_type'
  };

  function continueQuietIndexBuild(ctx, index, token, startPage) {
    function fetchNext(start) {
      if (token !== indexBuildToken) return Promise.resolve();

      return fetchJsonPageBatch(ctx.handle, start, PARALLEL_BATCH).then(function (batch) {
        if (token !== indexBuildToken) return;

        index.products = mergeProductLists(index.products, batch.products);
        index.complete = !batch.hasMore;
        index.nextRawPage = batch.hasMore ? start + PARALLEL_BATCH : start;
        index.ts = Date.now();
        syncBaseVisibleIndex(index);
        writeIndexCache(ctx.handle, index);
        notifyVisibleIndexUpdated();
        if (hasActiveFacetFilters()) {
          var filterCtx = getGridContext();
          if (filterCtx) {
            renderFilteredFromBase(filterCtx);
          }
        }

        if (batch.hasMore) {
          return fetchNext(start + PARALLEL_BATCH);
        }
      });
    }

    return fetchNext(startPage);
  }

  function ensureBaseIndexForFacetCounts(ctx, options) {
    if (!ctx) return Promise.resolve(null);
    if (baseVisibleIndex && baseVisibleIndex.products.length) {
      return Promise.resolve(baseVisibleIndex);
    }

    var opts = options || {};
    var maxInitialPages = opts.lightIndex ? Math.min(2, getInitialJsonPages(ctx)) : getInitialJsonPages(ctx);

    var cached = readIndexCache(ctx.handle);
    if (cached && Array.isArray(cached.products) && cached.products.length) {
      var cachedIndex = {
        products: cached.products.slice(),
        complete: !!cached.complete,
        nextRawPage: cached.nextRawPage || 1,
        ts: cached.ts || Date.now()
      };
      syncBaseVisibleIndex(cachedIndex);
      if (!cachedIndex.complete) {
        var quietToken = ++indexBuildToken;
        continueQuietIndexBuild(ctx, cachedIndex, quietToken, cachedIndex.nextRawPage);
      }
      notifyVisibleIndexUpdated();
      return Promise.resolve(baseVisibleIndex);
    }

    var quietToken = ++indexBuildToken;
    return fetchJsonPageBatch(ctx.handle, 1, maxInitialPages).then(function (batch) {
      if (quietToken !== indexBuildToken) return baseVisibleIndex;

      var index = {
        products: batch.products.slice(),
        complete: !batch.hasMore,
        nextRawPage: maxInitialPages + 1,
        ts: Date.now()
      };
      syncBaseVisibleIndex(index);
      writeIndexCache(ctx.handle, index);
      notifyVisibleIndexUpdated();

      if (!index.complete) {
        continueQuietIndexBuild(ctx, index, quietToken, index.nextRawPage);
      }

      return baseVisibleIndex;
    });
  }

  function computeSidebarFacetCountMaps() {
    if (!baseVisibleIndex || !Array.isArray(baseVisibleIndex.products) || !baseVisibleIndex.products.length) {
      return Promise.resolve(null);
    }

    var filters = collectActiveFacetFilters();
    return fetchProductsMetaMap(baseVisibleIndex.products).then(function (metaMap) {
      var metas = Object.keys(metaMap).map(function (handle) {
        return metaMap[handle];
      });
      var maps = {
        publisher: Object.create(null),
        category: Object.create(null),
        subCategory: Object.create(null),
        author: Object.create(null),
        bookType: Object.create(null)
      };

      Object.keys(FACET_DIMENSION_PARAMS).forEach(function (dimension) {
        var scopedFilters = excludeFilterParamForDimension(filters, dimension);
        var scopedProducts = filterVisibleProducts(baseVisibleIndex.products, scopedFilters, metaMap);
        var dimensionMaps = buildFacetCountMapsForProducts(scopedProducts, metas);
        maps[dimension] = dimensionMaps[dimension] || Object.create(null);
      });

      return maps;
    });
  }

  function buildFacetCountMapsForProducts(products, metas) {
    var metaByHandle = new Map();
    metas.forEach(function (meta) {
      if (meta && meta.handle) metaByHandle.set(meta.handle, meta);
    });

    var maps = {
      publisher: Object.create(null),
      category: Object.create(null),
      subCategory: Object.create(null),
      author: Object.create(null),
      bookType: Object.create(null)
    };

    products.forEach(function (product) {
      var vendorKey = normalize(product.vendor);
      if (vendorKey) {
        maps.publisher[vendorKey] = (maps.publisher[vendorKey] || 0) + 1;
      }

      var meta = metaByHandle.get(product.handle) || {
        handle: product.handle,
        vendor: product.vendor,
        l1: product.l1 || '',
        l2: product.l2 || '',
        l3: product.l3 || '',
        l4: product.l4 || '',
        combined: '',
        author: '',
        bookType: '',
        productType: product.productType || ''
      };

      if (!meta.l1 && product.l1) meta.l1 = product.l1;
      if (!meta.l2 && product.l2) meta.l2 = product.l2;
      if (!meta.l3 && product.l3) meta.l3 = product.l3;
      if (!meta.l4 && product.l4) meta.l4 = product.l4;
      if (!meta.productType && product.productType) meta.productType = product.productType;

      var categoryValue = meta.productType || meta.l1;
      if (categoryValue) {
        var categoryKey = normalize(categoryValue);
        maps.category[categoryKey] = (maps.category[categoryKey] || 0) + 1;
      }

      var combinedPath = getCombinedPath(meta, product);
      if (combinedPath) {
        var subKey = normalize(combinedPath);
        maps.subCategory[subKey] = (maps.subCategory[subKey] || 0) + 1;
      }

      if (meta.author) {
        var authorKey = normalize(meta.author);
        maps.author[authorKey] = (maps.author[authorKey] || 0) + 1;
      }

      if (meta.bookType) {
        var bookTypeKey = normalize(meta.bookType);
        maps.bookType[bookTypeKey] = (maps.bookType[bookTypeKey] || 0) + 1;
      }
    });

    return maps;
  }

  var LC_FILTER_DIMENSIONS = [
    { key: 'category', label: 'Category', param: 'filter.p.product_type' },
    { key: 'subCategory', label: 'Sub Category', param: 'filter.p.m.custom.combined_product_tags' },
    { key: 'author', label: 'Author', param: 'filter.p.m.custom.author' },
    { key: 'publisher', label: 'Publisher', param: 'filter.p.vendor' },
    { key: 'bookType', label: 'Book Type', param: 'filter.p.m.custom.book_type' }
  ];

  function createLargeCollectionValueBuckets() {
    return {
      category: Object.create(null),
      subCategory: Object.create(null),
      author: Object.create(null),
      publisher: Object.create(null),
      bookType: Object.create(null)
    };
  }

  function rememberLargeCollectionValue(bucket, normalizedKey, displayValue) {
    if (!normalizedKey || !displayValue) return;
    if (!bucket[normalizedKey]) {
      bucket[normalizedKey] = {
        value: displayValue,
        label: displayValue,
        count: 0
      };
    }
    bucket[normalizedKey].count += 1;
  }

  function populateLargeCollectionValueBuckets(buckets, products, metaMap) {
    (products || []).forEach(function (product) {
      var meta = metaMap[product.handle] || {};

      if (product.vendor) {
        rememberLargeCollectionValue(buckets.publisher, normalize(product.vendor), product.vendor);
      }

      var categoryValue = String((meta.productType || product.productType || '')).trim();
      if (categoryValue) {
        rememberLargeCollectionValue(buckets.category, normalize(categoryValue), categoryValue);
      }

      var combinedPath = getCombinedPath(meta, product);
      if (combinedPath) {
        rememberLargeCollectionValue(buckets.subCategory, normalize(combinedPath), combinedPath);
      }

      var author = String(meta.author || '').trim();
      if (author) {
        rememberLargeCollectionValue(buckets.author, normalize(author), author);
      }

      var bookType = String(meta.bookType || '').trim();
      if (bookType) {
        rememberLargeCollectionValue(buckets.bookType, normalize(bookType), bookType);
      }
    });
  }

  function applyScopedCountsToBuckets(buckets, maps) {
    if (!maps) return;

    LC_FILTER_DIMENSIONS.forEach(function (dimension) {
      var bucket = buckets[dimension.key];
      var countMap = maps[dimension.key] || Object.create(null);
      Object.keys(bucket).forEach(function (normalizedKey) {
        bucket[normalizedKey].count = countMap[normalizedKey] || 0;
      });
    });
  }

  function assembleLargeCollectionFilters(buckets, options) {
    var opts = options || {};
    var activeFilters = collectActiveFacetFilters();
    var filters = [];

    LC_FILTER_DIMENSIONS.forEach(function (dimension) {
      var bucket = buckets[dimension.key];
      var paramName = dimension.param;
      var activeValues = activeFilters.byParam[paramName] || [];
      var values = Object.keys(bucket).map(function (normalizedKey) {
        var entry = bucket[normalizedKey];
        return {
          value: entry.value,
          label: entry.label,
          count: entry.count || 0,
          param_name: paramName,
          active: activeValues.indexOf(entry.value) !== -1
        };
      }).sort(function (a, b) {
        return String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' });
      });

      if (values.length === 0) return;

      filters.push({
        type: 'list',
        label: dimension.label,
        param_name: paramName,
        values: values,
        approximateCounts: !!opts.approximate
      });
    });

    return filters;
  }

  function dimensionForParam(paramName) {
    if (!paramName) return null;
    if (paramName === FACET_DIMENSION_PARAMS.publisher) return 'publisher';
    if (paramName === FACET_DIMENSION_PARAMS.category) return 'category';
    if (paramName.indexOf('combined_product_tags') !== -1) return 'subCategory';
    if (paramName.indexOf('author') !== -1) return 'author';
    if (paramName.indexOf('book_type') !== -1) return 'bookType';
    if (paramName.indexOf('1st_product_tag') !== -1 || paramName.indexOf('product_type') !== -1) {
      return 'category';
    }
    return null;
  }

  function countProductsByFilterParam(products, metaMap, paramName) {
    var counts = Object.create(null);
    (products || []).forEach(function (product) {
      var meta = metaMap[product.handle] || {};
      var value = String(resolveFilterValue(product, meta, paramName) || '').trim();
      if (!value) return;
      var key = normalize(value);
      if (!counts[key]) {
        counts[key] = {
          value: value,
          label: value,
          count: 0
        };
      }
      counts[key].count += 1;
    });
    return counts;
  }

  function buildNativeAlignedLargeCollectionFilters(nativeFilters, metaMap, options) {
    var opts = options || {};
    var approximate = !!opts.approximate;
    var scopedMaps = opts.scopedMaps || null;
    var activeFilters = collectActiveFacetFilters();
    var filters = [];

    (nativeFilters || []).forEach(function (nativeFilter) {
      if (!nativeFilter) return;
      if (nativeFilter.type === 'price_range') {
        filters.push(nativeFilter);
        return;
      }
      if (!nativeFilter.param_name || !Array.isArray(nativeFilter.values)) return;

      var indexedCounts = countProductsByFilterParam(
        baseVisibleIndex.products,
        metaMap,
        nativeFilter.param_name
      );
      var dimension = dimensionForParam(nativeFilter.param_name);
      var scopedMap = dimension && scopedMaps ? scopedMaps[dimension] : null;
      var activeValues = activeFilters.byParam[nativeFilter.param_name] || [];
      var valueMap = Object.create(null);

      nativeFilter.values.forEach(function (nativeVal) {
        var key = normalize(nativeVal.value);
        if (!key) return;
        var count = indexedCounts[key] ? indexedCounts[key].count : 0;
        if (scopedMap && scopedMap[key] != null) {
          count = scopedMap[key];
        } else if (!indexedCounts[key] && nativeVal.count != null) {
          count = nativeVal.count;
        }
        valueMap[key] = {
          value: nativeVal.value,
          label: nativeVal.label || nativeVal.value,
          count: count || 0,
          param_name: nativeVal.param_name || nativeFilter.param_name,
          active: activeValues.indexOf(nativeVal.value) !== -1
        };
      });

      Object.keys(indexedCounts).forEach(function (key) {
        if (valueMap[key]) return;
        var count = indexedCounts[key].count || 0;
        if (scopedMap && scopedMap[key] != null) {
          count = scopedMap[key];
        }
        valueMap[key] = {
          value: indexedCounts[key].value,
          label: indexedCounts[key].label,
          count: count,
          param_name: nativeFilter.param_name,
          active: activeValues.indexOf(indexedCounts[key].value) !== -1
        };
      });

      var values = Object.keys(valueMap).map(function (key) {
        return valueMap[key];
      }).sort(function (a, b) {
        return String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' });
      });

      if (values.length === 0) return;

      filters.push({
        type: 'list',
        label: nativeFilter.label,
        param_name: nativeFilter.param_name,
        values: values,
        approximateCounts: approximate
      });
    });

    return filters;
  }

  function buildLargeCollectionFilterCatalog(options) {
    if (!baseVisibleIndex || !Array.isArray(baseVisibleIndex.products) || !baseVisibleIndex.products.length) {
      return Promise.resolve(null);
    }

    var opts = options || {};
    var approximate = opts.approximate != null ? !!opts.approximate : !baseVisibleIndex.complete;
    var nativeFilters = Array.isArray(opts.nativeFilters) ? opts.nativeFilters : [];

    if (nativeFilters.length > 0 && !opts.scopedCounts) {
      var quickAligned = buildNativeAlignedLargeCollectionFilters(nativeFilters, {}, {
        approximate: approximate,
        scopedMaps: null
      });
      if (quickAligned.length > 0) {
        return Promise.resolve(quickAligned);
      }
    }

    return fetchProductsMetaMap(baseVisibleIndex.products).then(function (metaMap) {
      var scopedPromise = opts.scopedCounts && hasActiveFacetFilters()
        ? computeSidebarFacetCountMaps()
        : Promise.resolve(null);

      return scopedPromise.then(function (scopedMaps) {
        if (nativeFilters.length > 0) {
          var aligned = buildNativeAlignedLargeCollectionFilters(nativeFilters, metaMap, {
            approximate: approximate,
            scopedMaps: scopedMaps
          });
          if (aligned.length > 0) {
            return aligned;
          }
        }

        var buckets = createLargeCollectionValueBuckets();
        populateLargeCollectionValueBuckets(buckets, baseVisibleIndex.products, metaMap);
        if (scopedMaps) {
          applyScopedCountsToBuckets(buckets, scopedMaps);
        }
        return assembleLargeCollectionFilters(buckets, { approximate: approximate });
      });
    });
  }

  function collectActiveFacetFilters() {
    var params = new URLSearchParams(window.location.search);
    var filters = {
      byParam: {},
      priceMin: null,
      priceMax: null
    };

    params.forEach(function (value, key) {
      if (!value) return;
      if (key === 'filter.v.price.gte') {
        filters.priceMin = parseFloat(value, 10);
        return;
      }
      if (key === 'filter.v.price.lte') {
        filters.priceMax = parseFloat(value, 10);
        return;
      }
      if (key.indexOf('filter.') === 0) {
        if (!filters.byParam[key]) filters.byParam[key] = [];
        filters.byParam[key].push(value);
      }
    });

    return filters;
  }

  function filterRequiresProductMeta(paramKey) {
    if (!paramKey) return false;
    if (paramKey === 'filter.p.vendor' || paramKey === 'filter.p.product_type') return false;
    if (paramKey.indexOf('filter.v.price') === 0) return false;
    return true;
  }

  function needsProductMetaForFilters(filters) {
    return Object.keys(filters.byParam).some(filterRequiresProductMeta);
  }

  function readMetaCache(handle) {
    if (metaCacheMemory.has(handle)) return metaCacheMemory.get(handle);
    try {
      var raw = sessionStorage.getItem(META_CACHE_PREFIX + handle);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || Date.now() - data.ts > META_CACHE_TTL) return null;
      metaCacheMemory.set(handle, data.meta);
      return data.meta;
    } catch (error) {
      return null;
    }
  }

  function writeMetaCache(handle, meta) {
    if (!meta || !handle) return;
    metaCacheMemory.set(handle, meta);
    try {
      sessionStorage.setItem(
        META_CACHE_PREFIX + handle,
        JSON.stringify({ meta: meta, ts: Date.now() })
      );
    } catch (error) {
      /* ignore quota errors */
    }
  }

  function fetchProductMeta(handle) {
    var cached = readMetaCache(handle);
    if (cached) return Promise.resolve(cached);

    return fetch('/products/' + encodeURIComponent(handle) + '?view=kitaboo-meta', {
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.ok ? res.text() : null;
      })
      .then(function (text) {
        if (!text) return null;
        try {
          var meta = JSON.parse(text.trim());
          if (meta && meta.handle) {
            writeMetaCache(handle, meta);
          }
          return meta;
        } catch (error) {
          return null;
        }
      })
      .catch(function () {
        return null;
      });
  }

  function fetchProductsMetaMap(products) {
    var handles = [];
    var seen = new Set();
    (products || []).forEach(function (product) {
      if (!product.handle || seen.has(product.handle)) return;
      if (readMetaCache(product.handle)) return;
      seen.add(product.handle);
      handles.push(product.handle);
    });

    var map = {};
    (products || []).forEach(function (product) {
      if (!product.handle) return;
      var cached = readMetaCache(product.handle);
      if (cached) map[product.handle] = cached;
    });

    var index = 0;

    function runBatch() {
      if (index >= handles.length) return Promise.resolve(map);
      var batch = handles.slice(index, index + META_FETCH_BATCH);
      index += META_FETCH_BATCH;
      return Promise.all(batch.map(fetchProductMeta)).then(function (results) {
        results.forEach(function (meta) {
          if (meta && meta.handle) map[meta.handle] = meta;
        });
        return runBatch();
      });
    }

    return runBatch();
  }

  function getCombinedPath(meta, product) {
    if (meta && meta.combined) return String(meta.combined).trim();
    var parts = [
      (meta && meta.l1) || product.l1,
      (meta && meta.l2) || product.l2,
      (meta && meta.l3) || product.l3,
      (meta && meta.l4) || product.l4
    ].filter(function (part) {
      return part && String(part).trim();
    });
    return parts.join('|');
  }

  function matchesFilterValues(values, candidate) {
    if (!values || !values.length) return true;
    var normalizedCandidate = normalize(candidate);
    if (!normalizedCandidate) return false;
    return values.some(function (value) {
      var normalizedValue = normalize(value);
      return (
        normalizedCandidate === normalizedValue ||
        normalizedCandidate.indexOf(normalizedValue + '|') === 0 ||
        normalizedCandidate.indexOf('|' + normalizedValue + '|') !== -1 ||
        normalizedCandidate.slice(-normalizedValue.length - 1) === '|' + normalizedValue
      );
    });
  }

  function resolveFilterValue(product, meta, paramKey) {
    if (paramKey === 'filter.p.vendor') return product.vendor || '';
    if (paramKey === 'filter.p.product_type') {
      return (meta && meta.productType) || product.productType || '';
    }
    if (paramKey.indexOf('1st_product_tag') !== -1) {
      return (meta && meta.l1) || product.l1 || '';
    }
    if (paramKey.indexOf('combined_product_tags') !== -1) {
      return getCombinedPath(meta, product);
    }
    if (paramKey.indexOf('author') !== -1) {
      return (meta && meta.author) || '';
    }
    if (paramKey.indexOf('book_type') !== -1) {
      return (meta && meta.bookType) || '';
    }
    return '';
  }

  function productMatchesFacetFilters(product, meta, filters) {
    var paramKeys = Object.keys(filters.byParam);
    for (var i = 0; i < paramKeys.length; i += 1) {
      var key = paramKeys[i];
      var candidate = resolveFilterValue(product, meta || {}, key);
      if (!matchesFilterValues(filters.byParam[key], candidate)) return false;
    }

    if (filters.priceMin != null) {
      var minPrice = parseFloat(product.price, 10);
      if (!Number.isFinite(minPrice) || minPrice < filters.priceMin) return false;
    }

    if (filters.priceMax != null) {
      var maxPrice = parseFloat(product.price, 10);
      if (!Number.isFinite(maxPrice) || maxPrice > filters.priceMax) return false;
    }

    return true;
  }

  function filterVisibleProducts(products, filters, metaMap) {
    return (products || []).filter(function (product) {
      var meta = metaMap[product.handle] || {};
      return productMatchesFacetFilters(product, meta, filters);
    });
  }

  function ensureBaseVisibleIndex(ctx) {
    if (baseVisibleIndex && baseVisibleIndex.products.length) {
      return Promise.resolve(baseVisibleIndex);
    }

    if (baseVisibleIndex && baseVisibleIndex.complete) {
      return Promise.resolve(baseVisibleIndex);
    }

    var serverProducts = extractServerRenderedProducts(ctx);
    rememberCardTemplate(ctx);
    var initialPages = getInitialJsonPages(ctx);
    return buildVisibleIndex(ctx, initialPages, serverProducts).then(function (index) {
      syncBaseVisibleIndex(index);
      return baseVisibleIndex || index;
    });
  }

  function ensureBaseVisibleIndexForFiltering(ctx) {
    if (baseVisibleIndex && baseVisibleIndex.products.length) {
      return Promise.resolve(baseVisibleIndex);
    }

    if (baseVisibleIndex && baseVisibleIndex.complete) {
      return Promise.resolve(baseVisibleIndex);
    }

    rememberCardTemplate(ctx);
    return ensureBaseIndexForFacetCounts(ctx, { lightIndex: true }).then(function () {
      return baseVisibleIndex;
    });
  }

  function hasServerFilteredCountReady() {
    return !!document.querySelector('#ProductCount[data-count-ready="true"], #ProductCountDesktop[data-count-ready="true"]');
  }

  function buildFilteredIndexOnly(ctx) {
    if (!ctx || !baseVisibleIndex || !hasActiveFacetFilters()) {
      return Promise.resolve();
    }

    var filters = collectActiveFacetFilters();
    var metaPromise = needsProductMetaForFilters(filters)
      ? fetchProductsMetaMap(baseVisibleIndex.products)
      : Promise.resolve({});

    return metaPromise.then(function (metaMap) {
      var filtered = filterVisibleProducts(baseVisibleIndex.products, filters, metaMap);
      activeIndex = {
        products: filtered,
        complete: !!baseVisibleIndex.complete,
        ts: Date.now()
      };

      if (ctx.grid) {
        ctx.grid.dataset.kitabooHydrated = 'filtered';
      }

      if (!hasServerFilteredCountReady()) {
        setProductCount(filtered.length, {
          approximate: !baseVisibleIndex.complete,
          filtered: true
        });
      }

      if (baseVisibleIndex.complete) {
        renderPagination(ctx, getCurrentPage());
      }

      notifyVisibleIndexUpdated();
    });
  }

  function warmFilteredIndex() {
    var ctx = getGridContext();
    if (!ctx || !hasActiveFacetFilters()) return Promise.resolve();

    return ensureBaseIndexForFacetCounts(ctx).then(function () {
      return buildFilteredIndexOnly(ctx);
    });
  }

  function renderFilteredFromBase(ctx) {
    if (!ctx || !baseVisibleIndex || !hasActiveFacetFilters()) {
      return Promise.resolve();
    }

    var filters = collectActiveFacetFilters();
    var metaPromise = needsProductMetaForFilters(filters)
      ? fetchProductsMetaMap(baseVisibleIndex.products)
      : Promise.resolve({});

    return metaPromise.then(function (metaMap) {
      var filtered = filterVisibleProducts(baseVisibleIndex.products, filters, metaMap);
      activeIndex = {
        products: filtered,
        complete: !!baseVisibleIndex.complete,
        ts: Date.now()
      };

      var page = getCurrentPage();
      var totalPages = Math.max(1, Math.ceil(filtered.length / ctx.perPage) || 1);
      if (page > totalPages) page = 1;

      if (ctx.grid) {
        ctx.grid.dataset.kitabooHydrated = 'filtered';
      }

      renderVisiblePage(ctx, activeIndex, page);
      renderPagination(ctx, page);
      setProductCount(filtered.length, {
        approximate: !baseVisibleIndex.complete,
        filtered: true
      });
      notifyVisibleIndexUpdated();
    });
  }

  function usesNativeFacetServerFiltering() {
    return hasActiveFacetFilters() && !document.querySelector('[data-large-collection="true"]');
  }

  function markServerFilteredCountReady() {
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(function (el) {
      if (el) {
        el.dataset.countReady = 'true';
        el.classList.remove('loading');
      }
    });
  }

  function resetFilteredView() {
    activeIndex = null;
    indexBuildToken += 1;
    var ctx = getGridContext();
    if (ctx && ctx.grid) {
      delete ctx.grid.dataset.kitabooHydrated;
    }
  }

  function rerenderFromBaseIndex(ctx, page) {
    var source = baseVisibleIndex || activeIndex;
    if (!source || !Array.isArray(source.products) || !source.products.length) return false;

    activeIndex = {
      products: source.products.slice(),
      complete: !!source.complete,
      nextRawPage: source.nextRawPage || 1,
      ts: source.ts || Date.now()
    };

    if (ctx && ctx.grid) {
      delete ctx.grid.dataset.kitabooHydrated;
    }

    renderVisiblePage(ctx, activeIndex, page);
    renderPagination(ctx, page);
    setProductCount(activeIndex.products.length, { approximate: !activeIndex.complete });
    notifyVisibleIndexUpdated();
    return true;
  }

  function refreshCollectionView() {
    var ctx = getGridContext();
    if (!ctx) return Promise.resolve();

    if (usesNativeFacetServerFiltering()) {
      markServerFilteredCountReady();
      return Promise.resolve();
    }

    if (hasActiveFacetFilters()) {
      if (document.querySelector('[data-large-collection="true"]') &&
          typeof window.__applyLargeCollectionExclusionFilters === 'function') {
        return window.__applyLargeCollectionExclusionFilters(window.location.search.slice(1));
      }
      return applyFacetFilters();
    }

    if (document.querySelector('[data-large-collection="true"]')) {
      var page = getCurrentPage();
      if (rerenderFromBaseIndex(ctx, page)) {
        return Promise.resolve();
      }
      resetCardTemplate();
      resetFilteredView();
      return bootstrapExclusionPagination();
    }

    if (activeIndex && Array.isArray(activeIndex.products)) {
      var activePage = getCurrentPage();
      renderVisiblePage(ctx, activeIndex, activePage);
      renderPagination(ctx, activePage);
      return Promise.resolve();
    }

    return bootstrapExclusionPagination();
  }

  function applyFacetFilters(options) {
    var ctx = getGridContext();
    var opts = options || {};
    if (!ctx || isBootstrapping) return Promise.resolve();

    if (usesNativeFacetServerFiltering()) {
      markServerFilteredCountReady();
      return Promise.resolve();
    }

    if (!hasActiveFacetFilters()) {
      return bootstrapExclusionPagination();
    }

    isBootstrapping = true;
    if (!opts.silent) {
      hidePendingCounts();
      setGridLoading(ctx, true);
      rememberCardTemplate(ctx);
    }

    return ensureBaseVisibleIndexForFiltering(ctx)
      .then(function () {
        return renderFilteredFromBase(ctx);
      })
      .then(function () {
        if (!baseVisibleIndex || baseVisibleIndex.complete) return;
        return ensureBaseVisibleIndex(ctx).then(function () {
          return renderFilteredFromBase(ctx);
        });
      })
      .finally(function () {
        if (!opts.silent) {
          setGridLoading(ctx, false);
        }
        isBootstrapping = false;
      });
  }

  function bootstrapExclusionPagination() {
    var ctx = getGridContext();
    if (!ctx || isBootstrapping) return Promise.resolve();

    if (usesNativeFacetServerFiltering()) {
      markServerFilteredCountReady();
      return Promise.resolve();
    }

    if (hasActiveFacetFilters()) {
      return applyFacetFilters();
    }

    var serverProducts = extractServerRenderedProducts(ctx);
    rememberCardTemplate(ctx);
    var keepServerHtml = serverProducts.length > 0 && getCurrentPage() === 1;
    var initialPages = getInitialJsonPages(ctx);

    isBootstrapping = true;
    hidePendingCounts();

    if (!keepServerHtml) {
      setGridLoading(ctx, true);
      delete ctx.grid.dataset.kitabooHydrated;
    } else {
      ctx.grid.dataset.kitabooHydrated = 'partial';
    }

    return buildVisibleIndex(ctx, initialPages, serverProducts)
      .then(function (index) {
        if (!index) return;
        var page = getCurrentPage();
        var sortedIndex = getSortedIndex(index);
        var start = (page - 1) * ctx.perPage;
        var slice = sortedIndex.products.slice(start, start + ctx.perPage);

        if (slice.length > 0 || index.complete) {
          renderVisiblePage(ctx, index, page);
        } else if (!keepServerHtml) {
          renderVisiblePage(ctx, index, page);
        } else {
          ctx.grid.dataset.kitabooHydrated = 'partial';
        }

        renderPagination(ctx, page);
        syncBaseVisibleIndex(index);
        setProductCount(index.products.length, { approximate: !index.complete });
        notifyVisibleIndexUpdated();
      })
      .finally(function () {
        setGridLoading(ctx, false);
        isBootstrapping = false;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.__redirectIfInvalidCollectionUrlParams === 'function' &&
        window.__redirectIfInvalidCollectionUrlParams()) {
      return;
    }

    var grid = document.getElementById('product-grid');
    if (!grid || grid.dataset.exclusionPagination !== 'true') {
      document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(function (el) {
        if (el) el.dataset.countReady = 'true';
      });
      return;
    }

    hidePendingCounts();

    if (hasActiveFacetFilters()) {
      if (document.querySelector('[data-large-collection="true"]')) {
        applyFacetFilters();
      } else {
        markServerFilteredCountReady();
      }
      return;
    }

    bootstrapExclusionPagination();
  });

  document.addEventListener('product-grid:updated', function () {
    if (isBootstrapping) return;
    var ctx = getGridContext();
    if (!ctx || hasActiveFacetFilters()) return;
    if (ctx.grid && (
      ctx.grid.dataset.kitabooHydrated === 'true' ||
      ctx.grid.dataset.kitabooHydrated === 'partial' ||
      ctx.grid.dataset.kitabooHydrated === 'pending' ||
      ctx.grid.dataset.kitabooHydrated === 'filtered'
    )) {
      return;
    }
    activeIndex = null;
    indexBuildToken += 1;
    bootstrapExclusionPagination();
  });

  window.addEventListener('popstate', function () {
    var ctx = getGridContext();
    if (!ctx) return;
    if (!document.querySelector('[data-large-collection="true"]')) return;

    if (hasActiveFacetFilters()) {
      if (typeof window.__applyLargeCollectionExclusionFilters === 'function') {
        window.__applyLargeCollectionExclusionFilters(window.location.search.slice(1)).then(function () {
          if (typeof window.__syncActiveFacetPills === 'function') {
            window.__syncActiveFacetPills();
          }
          if (typeof window.__refreshExclusionCollectionFacetUi === 'function') {
            return window.__refreshExclusionCollectionFacetUi(window.location.search.slice(1));
          }
        });
        return;
      }

      applyFacetFilters().then(function () {
        if (typeof window.__syncActiveFacetPills === 'function') {
          window.__syncActiveFacetPills();
        }
        if (typeof window.__refreshExclusionCollectionFacetUi === 'function') {
          return window.__refreshExclusionCollectionFacetUi(window.location.search.slice(1));
        }
      });
      return;
    }

    resetFilteredView();
    bootstrapExclusionPagination().then(function () {
      if (typeof window.__syncActiveFacetPills === 'function') {
        window.__syncActiveFacetPills();
      }
      if (typeof window.__syncLargeCollectionSidebarFilters === 'function') {
        return window.__syncLargeCollectionSidebarFilters();
      }
    });
  });

  window.KitabooExclusionPagination = {
    refresh: bootstrapExclusionPagination,
    applyFacetFilters: applyFacetFilters,
    warmFilteredIndex: warmFilteredIndex,
    refreshCollectionView: refreshCollectionView,
    rerenderFromBaseIndex: function () {
      var ctx = getGridContext();
      if (!ctx) return false;
      return rerenderFromBaseIndex(ctx, getCurrentPage());
    },
    resetFilteredView: resetFilteredView,
    resetCardTemplate: resetCardTemplate,
    getActiveIndex: function () {
      return activeIndex;
    },
    getBaseIndex: function () {
      return baseVisibleIndex;
    },
    ensureBaseIndexForFacetCounts: function (ctx, options) {
      return ensureBaseIndexForFacetCounts(ctx || getGridContext(), options);
    },
    computeSidebarFacetCountMaps: function () {
      return computeSidebarFacetCountMaps();
    },
    buildLargeCollectionFilterCatalog: function (options) {
      return buildLargeCollectionFilterCatalog(options || {});
    }
  };
})();
